import { useRef, useEffect } from "react";

export default function Logo() {
  const logoRef = useRef(null);
  const starRef = useRef(null);

  useEffect(() => {
    const logo = logoRef.current;
    const star = starRef.current;

    if (logo && star) {
      logo.addEventListener("mouseenter", () => {
        logo.style.transform = "scale(1.05)";
        logo.style.transition = "0.4s ease";
        star.style.transform = "rotate(20deg)";
        star.style.transformOrigin = "50% 50%";
      });

      logo.addEventListener("mouseleave", () => {
        logo.style.transform = "scale(1)";
        star.style.transform = "rotate(0deg)";
      });
    }

    return () => {
      if (logo) {
        logo.removeEventListener("mouseenter", null);
        logo.removeEventListener("mouseleave", null);
      }
    };
  }, []);

  return (
    <svg
      id="socializaLogo"
      ref={logoRef}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="15" fill="#1877F2" stroke="#1877F2" strokeWidth="2" />
      <text
        x="16"
        y="20"
        textAnchor="middle"
        fontSize="20"
        fontWeight="bold"
        fill="white"
        fontFamily="Arial"
      >
        S
      </text>
      <g id="star" ref={starRef}>
        <circle cx="24" cy="10" r="3" fill="#FFD700" />
      </g>
    </svg>
  );
}

